import { MantineProvider } from '@mantine/core';
import { createTheme, ThemeProvider as MUIThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { createContext, useContext } from 'react';
import { theme, Theme } from '../theme';
import { fontFace, baseFontFamily } from '../theme/fonts';

const ThemeContext = createContext<Theme>(theme);

export const useTheme = () => useContext(ThemeContext);

const muiTheme = createTheme({
  shape: {
    borderRadius: parseInt(theme.shape.borderRadius),
  },
  palette: {
    mode: 'light',
    primary: {
      main: theme.palette.primary.default,
      50: theme.palette.primary.x50,
      400: theme.palette.primary.x400,
      500: theme.palette.primary.x500,
      600: theme.palette.primary.x600,
    },
    secondary: {
      main: theme.palette.secondary.default,
      500: theme.palette.secondary.x500,
    },
    success: {
      main: theme.palette.success.default,
      50: theme.palette.success.x50,
      500: theme.palette.success.x500,
    },
    error: {
      main: theme.palette.danger.default,
      50: theme.palette.danger.x50,
      500: theme.palette.danger.x500,
    },
    background: {
      default: theme.palette.grey.x50,
    },
  },
  typography: {
    fontFamily: baseFontFamily,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: fontFace,
    },
  },
});

const mantineTheme = {
  fontFamily: baseFontFamily,
  colors: {
    brand: [
      theme.palette.primary.x50,
      theme.palette.primary.x200,
      theme.palette.primary.x400,
      theme.palette.primary.x500,
      theme.palette.primary.x600,
      theme.palette.primary.x700,
      theme.palette.primary.default,
      theme.palette.primary.default,
      theme.palette.primary.default,
      theme.palette.primary.default,
    ] as [
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string
    ],
  },
  primaryColor: 'brand',
};

export const ThemeProvider = ({ children }: { children: JSX.Element }) => {
  return (
    <ThemeContext.Provider value={theme}>
      <MantineProvider theme={mantineTheme}>
        <MUIThemeProvider theme={muiTheme}>
          <CssBaseline />
          {children}
        </MUIThemeProvider>
      </MantineProvider>
    </ThemeContext.Provider>
  );
};
